module.exports = __webpack_public_path__ + "img/paul_1.328d6277.jpg";